<template>
    <div class="x-postcontent x-postcontent-0 clearfix">
        <div class="x-content-layout layout-item-0">
            <div class="x-content-layout-row">
                <div
                    class="x-layout-cell layout-item-1"
                    style="width: 100%"
                    >
                    <table class="x-article" style="width: 100%; ">
                        <tbody>
                            <tr>
                                <td style="width: 100%; ">
                                    <h1 class="header">Even voorstellen</h1>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <br>
                    <div class="contact-info">
                        <h2>Contact informatie</h2>
                        <br>
                        <p>Telefoon: (020) 8852852<br>
                            Email: info@taxinummer.nl<br>
                            Adres: Weesperzijde 69<br>
                            Postcode: 1091 EH Amsterdam</p>
                    </div>
                    <h2>De medewerkers van Taxinummer</h2>
                    <br />
                    <div class="col-group">
                        <div class="col-mb-12 col-6 redactie-wrapper">
                            <img 
                                class="redactie-img"
                                alt=""
                                src="../assets/images/IMG_1638.jpg"
                                style="float: left; " />
                            <span style="font-weight: bold; ">Joke</span>
                            <p>
                                Taxijoke is duizendpoot en hoofdredacteur van Taxinummer. Zij is samen met haar zoon
                                Nills de oprichter van het magazine.<br>
                                Joke is 25 jaar taxichauffeur in Amsterdam geweest en werkt tegenwoordig als schipper
                                in Amsterdam.
                            </p>
                        </div>
                        <div class="col-mb-12 col-6 redactie-wrapper">
                            <img
                                class="redactie-img"
                                alt=""
                                src="../assets/images/willemijn.jpg"
                                style="float: left; "/>
                            <span style="font-weight: bold; " >Willemijn</span >
                            <p>
                            Willemijn van Breda schrijft de column In Amsterdam.<br>
                            Willemijn heeft kunstgeschiedenis gestudeerd en werkt sinds 1996 als gids. Onder haar
                            begeleiding wordt een rondleiding door Amsterdam een bijzondere ervaring.
                            </p>
                        </div>
                    </div>
                    <div class="col-group">
                        <div class="col-mb-12 col-6 redactie-wrapper">
                            <img
                                class="redactie-img"
                                alt=""
                                src="../assets/images/marjan.jpg"
                                style="float: left; " />
                            <span style="font-weight: bold; ">Marjan<br /></span>
                            <p>
                                Marjan Delzenne doet de eindredactie, samen met Taxijoke. En schrijft regelmatig voor
                                de column Internationaal.<br>
                                Marjan heeft het Centrum voor budgetmonitoring opgericht. Tegenwoordig is ze
                                financieel adviseur.
                            </p>
                        </div>
                        <div class="col-mb-12 col-6 redactie-wrapper">
                            <img
                                class="redactie-img"
                                alt=""
                                src="../assets/images/grobbe.jpg"
                                style="float: left; "/>
                            <span style="font-weight: bold; " >Grobbe</span >
                            <p>
                            Grobbe is al vijfendertig jaar taxichauffeur in Amsterdam. Hij kent de stad op zijn
                            duimpje. In zijn columns neemt hij de bureaucratie van de overheid op de hak. Maar hij
                            schrijft ook prachtige verhalen over zijn klanten.
                            </p>

                        </div>
                    </div>
                    <div class="col-group">
                        <div class="col-mb-12 col-6 redactie-wrapper">
                            <img
                                class="redactie-img"
                                alt=""
                                src="../assets/images/merijn.jpg"
                                style="float: left; "/>
                            <span style="font-weight: bold; " >Merijn&nbsp;</span >
                            <p>
                            Merijn Rutgers maakt cartoons voor Taxinummer.
                            Naast deze werkzaamheden is hij kunstschilder en ontwerpt hij websites met een custom
                            design. Ook realiseert hij zoekmachine optimalisatie.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style>

.redactie-img{
    width: 111px;
    height: 200px;
}

@media (min-width: 768px) {
    .redactie-img{
        width: 166px;
        height: 299px;
    }
}

.redactie-wrapper{
    margin-bottom: 10px
}

.redactie-wrapper > p{
    font-size: 14px;
}

.redactie-wrapper > span{
    display: none;
}

.contact-info > p{
    margin-left: 20px;
    font-size: 16px;
}
.contact-info{
    background: rgba(0,0,0,0.8);
    padding: 10px;
    margin-bottom: 50px;
}

</style>

<script>
// @ is an alias to /src

    export default {
        name: 'redactie',
    }
</script>
